import React, {Component} from 'react'
import {connect} from 'react-redux'
import { Input, Form, Button, TextArea, Icon, Message, Popup } from 'semantic-ui-react'
import { isEmailValid } from "../../Constants/isEmailValid";
import bytesToMB from '../../Constants/bytesToMB'
import API_Root from '../../Constants/API_Root'
import SupportTopicSelection from "./SupportTopicSelection";
import {toggleModal} from "../../Actions/ToggleModal";
import {modifyModalInfo} from "../../Actions/ModifyModalInfo";
import SupportTierMessage from "./SupportTierMessage";
import {getSupportMessage} from "./getSupportMessage";
import {capitalize} from "../../Constants/capitalize";

class SupportModalBody extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            email: localStorage.getItem("email"),
            subject: '',
            message: '',
            supportFiles: null,
            supportTopic: null,
            sending: false,
            responseMessage: null,
            fileMessage: null
        }

        this.dismissMessage = this.dismissMessage.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleFileUpload = this.handleFileUpload.bind(this);
        this.emailValid = this.emailValid.bind(this);
        this.sendSupport = this.sendSupport.bind(this);
        this.dismissFileMessage = this.dismissFileMessage.bind(this);
        this.clearFiles = this.clearFiles.bind(this);
    }

    sendSupport(e){
        // const errorMessage = <Message
        //     onDismiss={this.dismissMessage}
        //     content={<span>There was an error storing your support request. Please <a href="mailto:support@apispreadsheets.com?Subject=Support">email us at support@apispreadsheets.com</a> directly.</span>}
        //     negative
        // />

        const error = () => this.setState({ sending: false }, () =>
        {
            this.props.toggleModal(null)
            this.props.modifyModalInfo({ supportInfo: { success: false } });
            this.props.toggleModal("supportConfirmationModal");
        })

        this.setState({
            sending: true
        })

        let formData = new FormData();

        // Add Files to Form Data
        if (this.state.supportFiles !== null){
            for (let i=0; i<this.state.supportFiles.length; i++){
                formData.append("file" + i.toString(), this.state.supportFiles[i]);
            }
        }

        // Add form info
        formData.append("topic", this.state.supportTopic)
        formData.append("email", this.state.email)
        formData.append("subject", this.state.subject);
        formData.append("message", this.state.message);
        formData.append("name", this.state.name);
        formData.append("userEmail", localStorage.getItem("email"));
        formData.append("responseMsg", JSON.stringify(getSupportMessage(this.props.tier)))

        fetch(API_Root + 'api/store-love-spreadsheets-support/', {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain, */*',
            },
            body: formData
        }).then((res) => {
            if (res.status === 201){
                this.setState({
                    sending: false,
                }, () => {
                    this.props.toggleModal(null)
                    this.props.modifyModalInfo({ supportInfo: { email: this.state.email, success: true} });
                    this.props.toggleModal("supportConfirmationModal");
                })
            }
            else{
                error()
            }
        }).catch(err => {
            error()
        })
    }

    clearFiles(e){
        this.setState({
            supportFiles: null,
            fileMessage: null
        })
    }


    handleFileUpload(e){
        const files = e.target.files;

        if (files.length > 0){
            let fileSize = 0;

            for (let i=0; i<files.length; i++){
                fileSize += bytesToMB(files[i].size);
            }

            if (this.state.supportFiles !== null){
                for (let j=0; j<this.state.supportFiles.length; j++){
                    fileSize += bytesToMB(this.state.supportFiles[j].size);
                }
            }

            if (fileSize <= 5){
                this.setState({
                    supportFiles: files,
                })
            }
            else{
                const fileMessage = <Message
                    onDismiss={this.dismissFileMessage}
                    content="You cannot upload more than 5MB Total"
                    negative
                />;

                this.setState({
                    fileMessage: fileMessage
                })
            }


        }
    }

    handleInputChange(e){
        const name = e.target.name;
        const value = e.target.value;

        if (name === "subject"){
            if (value.length <= 75){
                this.setState({
                    [name]: value
                })
            }
        }
        else if (name === "message"){
            if (value.length <= 5000){
                this.setState({
                    [name]: value
                })
            }
        }
        else{
            this.setState({
                [name]: value
            })
        }
    }

    dismissMessage(e){
        this.setState({
            responseMessage: null
        })
    }

    dismissFileMessage(e){
        this.setState({
            fileMessage: null
        })
    }

    emailValid(){
        if (this.state.email !== null){
            if (this.state.email.trim() !== ""){
                return isEmailValid(this.state.email)
            }
            else{
                return true
            }
        }
        else{
            return true
        }
    }

    changeState = (newState) => this.setState(newState)

    getDocsURL = () => {
        let docsMap = {
            "api": "/api-docs",
            "importer": "/import-docs",
            "billing": this.props.isProductImporter ? "/importer/pricing#pricingFAQ" : "/pricing#pricingFAQ",
            "teams": "/api-docs/?docsMenuItem=teams",
            "database": this.props.isProductImporter ? "/import-docs/?docsMenuItem=database-introduction" : "/api-docs/?docsMenuItem=database-introduction",
            "general": this.props.isProductImporter ? "/import-docs" : "/api-docs",
            "utilities": "/utilities"
        }

        if (this.state.supportTopic in docsMap){
            return docsMap[this.state.supportTopic]
        } else {
            return "/api-docs"
        }
    }

    render() {
        const inputFileStyle = {
            width: '0.1px',
            height: '0.1px',
            opacity: '0',
            overflow: 'hidden',
            position: 'absolute',
            zIndex: '-1'
        };

        const emailError = !this.emailValid() ? <small className="inputError">Enter a valid email</small> : null;
        const subjectCharLeft = 75 - this.state.subject.length;
        const subjectCharMessage = subjectCharLeft.toString() + " character" + (subjectCharLeft !== 1 ? "s" : '') + " left";

        const detailCharLeft = 5000 - this.state.message.length;
        const detailCharMessage = detailCharLeft.toString() + " character" + (subjectCharLeft !== 1 ? "s" : '') + " left";

        let filesUploadedMessage = null;

        if (this.state.supportFiles !== null){
            let fileNames = [];

            for (let i=0; i<this.state.supportFiles.length; i++){
                fileNames.push(this.state.supportFiles[i].name);
            }

            filesUploadedMessage =<Message
                header={<span><b>Files Selected</b><button id="supportFormClearAllButton" onClick={this.clearFiles}>Clear All</button></span>}
                list={fileNames}
                positive
            />;
        }

        return (
            <div id="supportForm">
                <div style={{marginBottom: "16px"}}>
                    <SupportTierMessage
                        tier={this.props.tier}
                        page="support"
                    />
                </div>
                <span className="supportFormLabel">Your Name</span>
                <Input icon="user"
                       iconPosition="left"
                       name='name'
                       onChange={this.handleInputChange}
                       value={this.state.name} fluid />
                <br/>
                <span><span className="supportFormLabel">Preferred Email</span><small className="requiredLabel">Required</small></span>
                <Input  icon="at"
                        iconPosition='left'
                        type="email"
                        name="email"
                        onChange={this.handleInputChange}
                        error={!this.emailValid()}
                        value={this.state.email} fluid/>
                {emailError}
                <br/>
                <div style={{display: 'grid', gridTemplateColumns: "auto auto 1fr"}}>
                    <div>
                        <span><span className="supportFormLabel">What category most closely fits your issue?</span><small className="requiredLabel">Required</small></span>
                    </div>
                    <div style={{marginLeft: "16px"}}>
                        <SupportTopicSelection
                            value={this.state.supportTopic}
                            changeState={this.changeState}
                        />
                    </div>
                    <div style={{marginLeft: "16px"}}>
                        {this.state.supportTopic === null ? null : <div style={{padding: "8px", border: "1px solid #9696A0", borderRadius: "4px"}}>FYI: you can <a href={this.getDocsURL()} target="_blank" rel="noopener noreferrer">read docs for {capitalize(this.state.supportTopic)} here</a></div>}
                    </div>
                </div>
                <br/>
                <span><span className="supportFormLabel">Briefly Describe Your Issue</span><small className="requiredLabel">Required</small><small id="subjectCharLeft"><i>{"   " + subjectCharMessage}</i></small></span>
                <Input icon="bug"
                       iconPosition='left'
                       name="subject"
                       onChange={this.handleInputChange}
                       value={this.state.subject}
                       fluid />

                <br/>
                <span><span className="supportFormLabel">Provide As Much Detail As Possible</span><small id="subjectCharLeft"><i>{"  " + detailCharMessage}</i></small></span>
                <Form>
                    <TextArea
                        onChange={this.handleInputChange}
                        name="message"
                        value={this.state.message}
                        rows={6} />

                </Form>
                <br/>
                <input
                    type="file"
                    onChange={this.handleFileUpload}
                    style={inputFileStyle}
                    multiple={true}
                    name="inputFileUpload"
                    id="inputFileUpload"
                    accept=".txt, .csv, .xlsx, .png, .jpeg, .jpg, .doc, .docx, .pdf"
                />
                <span>
                    <span className="supportFormLabel">Upload Supporting Files</span>
                    <small id="subjectCharLeft">    5 MB Max</small>
                    <Popup fluid trigger={<Icon style={{paddingLeft: '4px', paddingTop: '2px'}} name="info circle"/>}>
                        <span><b>Following extensions valid</b></span>
                        <ul><li>.txt</li><li>.csv</li><li>.xlsx</li><li>.png</li><li>.jpeg</li><li>.jpg</li><li>.doc</li><li>.docx</li><li>.pdf</li></ul>
                    </Popup>
                </span>
                <br/>
                <label htmlFor="inputFileUpload">
                    <div className="buttonRaw" id="supportUploadFiles">
                        <Icon name="upload"/> Upload Files
                    </div>
                </label>
                {filesUploadedMessage}
                {this.state.fileMessage}
                <br/><br/>
                <Button content="Get Help"
                        icon="paper plane outline"
                        color="green"
                        onClick={this.sendSupport}
                        fluid
                        size="large"
                        loading={this.state.sending}
                        disabled={!this.emailValid() || this.state.subject.trim().length === 0 || this.state.supportTopic === null}/>
                <br/><br/>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    tier: state.mainState.tier,
    isProductImporter: state.mainState.isProductImporter
})

const mapActionsToProps = {
    toggleModal: toggleModal,
    modifyModalInfo: modifyModalInfo
}

export default connect(mapStateToProps, mapActionsToProps)(SupportModalBody)